export default "__VITE_ASSET__XHvhyv3s__"